/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { createComponentExtension, BackstagePlugin } from "@backstage/core";
import { honeybadgerApiPlugin } from "@internal/plugin-honeybadger-api";
import { Entity } from "@backstage/catalog-model";
import { HONEYBADGER_PROJECT_KEY_ANNOTATION } from "./hooks";

export const EntityHoneybadgerContent = (
  honeybadgerApiPlugin as unknown as BackstagePlugin<any, any>
).provide(
  createComponentExtension({
    component: {
      lazy: () => import("./views/EntityPanel").then((m) => m.EntityPanel),
    },
  })
);

export const EntityHoneybadgerOverviewCard = (
  honeybadgerApiPlugin as unknown as BackstagePlugin<any, any>
).provide(
  createComponentExtension({
    component: {
      lazy: () => import("./views/OverviewCard").then((m) => m.OverviewCard),
    },
  })
);

export const isHoneybadgerAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[HONEYBADGER_PROJECT_KEY_ANNOTATION]);
